import React from 'react';
import { Button, Header } from 'semantic-ui-react';
import Markdown from 'markdown-to-jsx';
import Image from '../../../atoms/Image';
import Modal from '../../../modules/foundation/components/Modal';
import { DEFAULT_MODAL_ANIMATION } from '../../../modules/foundation/components/Modal/Modal.constants';
import { ModalAnimationPropType } from '../../../modules/foundation/components/Modal/Modal.types';
import CloseIconDark from '../assets/CloseIconDark.png';
var defaultProps = {
  subTitle: '',
  content: '',
  extra: null,
  header: null,
  animation: DEFAULT_MODAL_ANIMATION
};
export default function MessageDisplayModal(_ref) {
  var businessName = _ref.businessName,
    open = _ref.open,
    subject = _ref.subject,
    subTitle = _ref.subTitle,
    content = _ref.content,
    onClose = _ref.onClose,
    extra = _ref.extra,
    header = _ref.header,
    animation = _ref.animation;
  return /*#__PURE__*/React.createElement(Modal, {
    className: "fm-message-display-modal",
    open: open,
    onClose: onClose,
    dimmer: "inverted",
    animation: animation
  }, /*#__PURE__*/React.createElement(Modal.Header, null, header || /*#__PURE__*/React.createElement("div", null, "Message from ", businessName), /*#__PURE__*/React.createElement(Button, {
    onClick: onClose,
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Image, {
    src: CloseIconDark,
    fluid: true
  }))), /*#__PURE__*/React.createElement(Modal.Content, {
    scrolling: true
  }, subject && /*#__PURE__*/React.createElement(Header, {
    className: "subject",
    as: "h4"
  }, subject), subTitle && /*#__PURE__*/React.createElement("div", {
    className: "fm-message-display-modal-subtitle"
  }, subTitle), content && /*#__PURE__*/React.createElement(Markdown, {
    className: "markdown"
  }, content), extra));
}
MessageDisplayModal.defaultProps = defaultProps;